import nopicture from "../assets/nopicture.png";

export const resolveContactAvatar = (contact) => {
  try {
    const url = contact?.urlPicture || contact?.profilePicUrl || "";
    if (typeof url === "string" && url.trim() !== "") {
      return url;
    }
  } catch (e) {
    // noop
  }
  return nopicture;
};

export const hasCustomAvatar = (contact) => {
  const url = resolveContactAvatar(contact);
  if (!url) return false;
  // nopicture importado como asset bundled - comparar pela referência
  return url !== nopicture && !url.includes("nopicture");
};

export const resolveTicketContactAvatar = (ticket) => {
  return resolveContactAvatar(ticket?.contact);
};
